import { decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives } from "../decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives";
import type { AllRouteEndpoints } from "../routeTypes";

export const postDecisioningStudioAgentsBaseCreativeCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
];
